import { createReducer, on } from '@ngrx/store';
import {
  addOREditFilter,
  deleteFilter,
  deleteAllFilters
} from '../actions/app.actions';
import { IFilter } from '@shared/models/filter.model';

export const initialState: IFilter[] = [];

const _filterReducer = createReducer(
  initialState,
  on(addOREditFilter, (state, { filter_name, value }) => {
    if (state.filter(filter => filter.filter_name == filter_name).length == 0) {
      return [
        ...state,
        {
          filter_name: filter_name,
          value: value
        }
      ];
    } else {
      return state.map(filter => {
        if (filter.filter_name != filter_name) {
          return filter;
        } else {
          return {
            filter_name: filter_name,
            value: value
          };
        }
      });
    }
  }),
  on(deleteFilter, (state, { filter_name }) =>
    state.filter(item => item.filter_name != filter_name)
  ),
  on(deleteAllFilters, state => [])
);

export function filterReducer(state, action) {
  return _filterReducer(state, action);
}
